// If you want to use Phoenix channels, run `mix help phx.gen.channel`
// to get started and then uncomment the line below.
// import "./user_socket.js"
// You can include dependencies in two ways.
//
// The simplest option is to put them in assets/vendor and
// import them using relative paths:
//
//     import "../vendor/some-package.js"
//
// Alternatively, you can `npm install some-package --prefix assets` and import
// them using a path starting with the package name:
//
//     import "some-package"
//
// Include phoenix_html to handle method=PUT/DELETE in forms and buttons.

import { BulkDownload } from "./hooks/BulkDownload";
import { Chart as UPlotChart } from "./chart-uplot/Chart";
import { Chart as ChartJS } from "./chart.js/Chart";
import { CodeEditorHook } from "./hooks/CodeEditorHook";
import { Copy } from "./hooks/Copy";
import { DownloadReport } from "./hooks/DownloadReport";
import { Faq } from "./hooks/Faq";
import { HLSVideo } from "./hooks/HLSVideo";
import { Map } from "./hooks/Map";
import { ScrollBottom } from "./hooks/ScrollBottom";
import { ScrollLogs } from "./hooks/ScrollLogs";
import { Webrtc } from "./hooks/Webrtc";
import { WebrtcTester } from "./hooks/WebrtcTester";
import { Tooltip } from "./hooks/Tooltip";
import { VolumeSlider } from "./hooks/VolumeSlider";
import { RemoteButton } from "./hooks/RemoteButton";
import { WindowPrompt } from "./hooks/WindowPrompt";
import { DropArea } from "./hooks/DropArea";
import { TextEditor } from "./hooks/Editor";
import { ProcessorController } from "./hooks/ProcessorController";
import { StaticTV } from "./hooks/StaticTV";
import { getHooks } from "live_svelte";
import { createLiveToastHook } from "live_toast";
import posthog from "posthog-js";

import topbar from "../vendor/topbar";
import * as uploaders from "./uploaders";
import "./data-confirm";
// Establish Phoenix Socket and LiveView configuration.
import { Socket } from "phoenix";
import "phoenix_html";
// TODO: Taos broken
// import "taos";
import { LiveSocket } from "phoenix_live_view";
import { addClipboard } from "./utils/clipboard";

import * as Components from "../svelte/*.svelte";

import * as Sentry from "@sentry/browser";

Sentry.init({
  dsn: document.body.dataset.sentryDsn,
  environment: document.body.dataset.sentryEnv,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.browserProfilingIntegration(),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
  tracePropagationTargets: [/^https:\/\/tvlabs\.ai/],
  tracesSampleRate: 1.0,
  profilesSampleRate: 1.0,
  // TODO: lower this to something like 0.1?
  // just want to test it out for now
  replaysSessionSampleRate: 1.0,
  replaysOnErrorSampleRate: 1.0,
});
posthog.init("phc_6TRQ0ANV3Quaa4qKoElM5R1gqlDRlZHtq7Ia0eFnvkG", {
  // Our nginx proxy running in Fly.io, see the `posthog/` directory
  api_host: "https://ph.tvlabs.ai",
  ui_host: "https://us.posthog.com",
});

const { userEmail, orgUserId, orgId, orgName } = document.body.dataset;

if (userEmail) {
  Sentry.setUser({ email: userEmail });
  posthog.identify(orgUserId, { email: userEmail, organization: orgName, organizationId: orgId });
}

window.addEventListener("phx:navigate", ({ detail: { href } }) => {
  let url = window.origin + href;
  if (window.location.search) {
    url = url + `?${window.location.search}`;
  }

  posthog.capture("$pageview", { $current_url: url });
});

let client_timezone;
try {
  client_timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
} catch (error) {
  console.log("Cannot fetch the user's timezone", error);
}

let csrfToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

let Hooks = {
  BulkDownload,
  ChartJS,
  CodeEditorHook,
  Copy,
  DownloadReport,
  Faq,
  HLSVideo,
  LiveToast: createLiveToastHook(2000),
  Map,
  ProcessorController,
  RemoteButton,
  ScrollBottom,
  ScrollLogs,
  StaticTV,
  SvelteHook: getHooks(Components).SvelteHook,
  TextEditor,
  Tooltip,
  UPlotChart,
  VolumeSlider,
  Webrtc,
  WebrtcTester,
  WindowPrompt,
  DropArea,
};

let liveSocket = new LiveSocket("/live", Socket, {
  longPollFallbackMs: location.host.startsWith("localhost") ? undefined : 2500,
  disconnectedTimeout: 3000,
  params: {
    _csrf_token: csrfToken,
    client_timezone,
  },
  hooks: Hooks,
  uploaders,
});

// Show progress bar on live navigation and form submits
topbar.config({ barColors: { 0: "#29d" }, shadowColor: "rgba(0, 0, 0, .3)" });
window.addEventListener("phx:page-loading-start", (_info) => topbar.show(300));
window.addEventListener("phx:page-loading-stop", (_info) => topbar.hide());
addClipboard();

// connect if there are any LiveViews on the page
liveSocket.connect();

// expose liveSocket on window for web console debug logs and latency simulation:
// >> liveSocket.enableDebug()
// >> liveSocket.enableLatencySim(1000)  // enabled for duration of browser session
// >> liveSocket.disableLatencySim()
window.liveSocket = liveSocket;
//# sourceMappingURL=app.js.map
